import { ButtonComponent } from '../../components/UI/ButtonComponent/ButtonComponent';
import faqLink from '../../assets/images/faqLink.svg';
import './shopifyPage.scss';
import {
	BeaconContent,
	NavigationLinks,
	PartnerContent,
	QuestionsContent,
	SubscriptionContent,
	SubscriptionModel
} from './model';

const Shopify = () => {
	const handleNavigateToCheckout = () => {
		window.open(NavigationLinks.shopify, '_blank');
	};
	return (
		<div className='shopifyPage'>
			<div className='beaconSubscriptionLogo'>
				<div className='beaconSubscriptionLogoLeft'></div>
				<div className='beaconSubscriptionLogoRight'>
					<h2>{SubscriptionModel.heading}</h2>
				</div>
			</div>
			<section className='heading'>
				<h2 className='shopifyPageHeading'>{SubscriptionModel.subHeading}</h2>
				<span className='price'>$2,000.00</span>

				<div className='button-container'>
					<ButtonComponent
						text={'Add to cart'}
						onClick={handleNavigateToCheckout}
						style='rounded-button primary'
						icon={<i className='ri-arrow-right-s-line line-icon'></i>}
					/>
				</div>
			</section>
			<section className='content'>
				<a
					className='emailContact'
					href={NavigationLinks.beaconDiscovery}
					target='_blank'
					rel='noopener noreferrer'
				>
					{BeaconContent.link}
				</a>
				{BeaconContent.content}
			</section>
			<section className='content'>
				<h3 className='contentHeading'>{PartnerContent.heading}</h3>
				{PartnerContent.content.firstContent}
				<a
					className='emailContact'
					href={NavigationLinks.howGood}
					target='_blank'
					rel='noopener noreferrer'
				>
					{PartnerContent.links.howGood}
				</a>
				{PartnerContent.content.secondContent}{' '}
				<a
					className='emailContact'
					href={NavigationLinks.marketVerified}
					target='_blank'
					rel='noopener noreferrer'
				>
					{PartnerContent.links.marketVerified}
				</a>{' '}
				{PartnerContent.content.thirdContent}
			</section>
			<section className='content'>
				<h3 className='contentHeading'>{SubscriptionContent.heading}</h3>
				{SubscriptionContent.content.firstContent}
				<a
					className='emailContact'
					href={NavigationLinks.beaconStandard}
					target='_blank'
					rel='noopener noreferrer'
				>
					{SubscriptionContent.links.here}
				</a>
			</section>
			<section className='content'>
				<h3 className='contentHeading'>{QuestionsContent.heading}</h3>
				<div className='faqLinkContainer'>
					<a className='faqLink' href={NavigationLinks.beaconFAQ} rel='noopener noreferrer'>
						<span>FAQ</span> <img src={faqLink} className='faqLink' alt='shopify-faq-link'></img>
					</a>
				</div>
				{QuestionsContent.content.firstContent}
				<a
					className='emailContact'
					href={QuestionsContent.links.audienceSuccess.link}
					target='_blank'
					rel='noopener noreferrer'
				>
					{QuestionsContent.links.audienceSuccess.content}
				</a>
				{QuestionsContent.content.secondContent}
				<a
					className='emailContact'
					href={QuestionsContent.links.standards.link}
					target='_blank'
					rel='noopener noreferrer'
				>
					{QuestionsContent.links.standards.content}
				</a>
			</section>
		</div>
	);
};

export default Shopify;
